module.exports = "export default __webpack_public_path__ + &quot;1bc3749b64f636617a65f5b2256805be.svg&quot;;"